import { H1 } from "@sellar-io/components";
import { HomeOrderNotifications } from "./HomeOrderNotifications";

export const RetailerHome = () => (
  <div className="w-full py-4">
    <HomeOrderNotifications />
    <H1 className="mt-4">Home</H1>
  </div>
);
